import { normalizePathPrefix as normalize, joinPaths } from '../utils/path';

const DEFAULT_PATH_PREFIX = '/';

declare global {
  interface Window {
    __PATH_PREFIX__?: string;
  }
}

function normalizePathPrefix(value?: string): string {
  return normalize(value, DEFAULT_PATH_PREFIX);
}

const runtimePrefix = window.__PATH_PREFIX__;
const sanitizedRuntimePrefix = runtimePrefix === '__PATH_PREFIX__' ? undefined : runtimePrefix;
export const PATH_PREFIX = normalizePathPrefix(sanitizedRuntimePrefix);

export function withPathPrefix(pathname: string): string {
  return joinPaths(PATH_PREFIX, pathname);
}

export function getApiPath(pathname: string): string {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return withPathPrefix(`/api${normalizedPath}`);
}
